import { Button, Center, Paper, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconActivity, IconRefresh } from '@tabler/icons-react';

interface EmptySessionStateProps {
  onStartSession: () => void;
}

export const EmptySessionState = ({ onStartSession }: EmptySessionStateProps) => {
  return (
    <Paper shadow="xs" p="xl" radius="md" withBorder>
      <Center>
        <Stack align="center" gap="md">
          <ThemeIcon color="gray" variant="light" radius="xl" size={80}>
            <IconActivity size={40} />
          </ThemeIcon>
          <Stack gap="xs" align="center">
            <Text size="lg" fw={600}>
              No Active Session
            </Text>
            <Text size="sm" c="dimmed" ta="center" maw={400}>
              Start a logging session to begin recording all API requests and database changes. Sessions automatically track incoming/outgoing requests and
              MongoDB modifications.
            </Text>
          </Stack>
          <Button onClick={onStartSession} variant="gradient" gradient={{ from: 'blue', to: 'cyan' }} size="md" leftSection={<IconRefresh size={18} />}>
            Start Logging Session
          </Button>
        </Stack>
      </Center>
    </Paper>
  );
};
